<template>
	<div class="cart-modal _modal">
		<div class="_modal-overlay" @click.self="$emit('close')"></div>
		<div class="cart-modal__inner _modal-inner">
			<div
				class="cart-modal__close _modal-close"
				@click="$emit('close')"
			></div>
			<div class="cart-modal__content">
				<div class="cart-modal__top">
					<div class="cart-modal__top-title _h3">
						{{ $t('shopping cart') }}
					</div>
					<div v-if="cartContents.length" class="cart-modal__top-count">
						({{ cartContents.length }} {{ 'items' }})
					</div>
				</div>
				<div v-if="cartContents.length" class="cart-modal__content">
					<div class="cart-modal__list">
						<div
							class="cart-modal__item"
							v-for="(item, i) in cartContents"
							:key="i"
						>
							<div class="cart-modal__wrapper">
								<div class="cart-modal__bg _ibg">
									<img src="@/assets/images/bg/yellow-blur.png" />
								</div>
								<div class="cart-modal__image _ibg-contain">
									<img :src="getImageUrl(item)" />
								</div>
							</div>
							<div class="cart-modal__about">
								<div class="cart-modal__info">
									<div class="cart-modal__info-name">
										{{ getSkinName(item.item.title) }}
									</div>
									<div class="cart-modal__info-wear">
										({{ getWear(item.item.title) }})
									</div>
								</div>
								<div class="cart-modal__about-type">
									{{ item.item.quality }}
								</div>
							</div>
							<div class="cart-modal__price">
								<div class="cart-modal__coin">
									<div class="cart-modal__coin-number">
										{{ item.item.price.toFixed(2) }}
										{{ currencySymbol }}
									</div>
									<!--<div class="cart-modal__coin-icon _ibg-contain">
										<img src="@/assets/images/icons/coin.svg" />
									</div>-->
								</div>
								<!--<div class="cart-modal__real">
									<div class="cart-modal__real-number">
										{{ item.item.price.toFixed(2) }}
									</div>
									<div class="cart-modal__real-symbol">
										{{ currencySymbol }}
									</div>
								</div>-->
							</div>
							<button
								class="cart-modal__delete"
								@click="handleDelete(item)"
							>
								<svg
									width="16"
									height="20"
									viewBox="0 0 16 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M9.71973 0C10.1174 0 10.499 0.158368 10.7803 0.439453C11.0615 0.720657 11.2196 1.10233 11.2197 1.5V2H15.4004C15.5329 2.0001 15.6602 2.05282 15.7539 2.14648C15.8476 2.24015 15.9003 2.36755 15.9004 2.5C15.9004 2.63242 15.8474 2.75979 15.7539 2.85352C15.6602 2.94719 15.5329 2.9999 15.4004 3H14.6797L14.2598 17.4502C14.2433 18.1014 13.9729 18.7207 13.5059 19.1748C13.0386 19.629 12.4114 19.8829 11.7598 19.8809H4.13965C3.48815 19.8828 2.86171 19.6289 2.39453 19.1748C1.92738 18.7206 1.65611 18.1015 1.63965 17.4502L1.21973 3H0.5C0.367392 3 0.240253 2.94728 0.146484 2.85352C0.0528497 2.75977 0 2.63251 0 2.5C0.000113018 2.36755 0.0528169 2.24015 0.146484 2.14648C0.240232 2.05285 0.367493 2 0.5 2H4.67969V1.5C4.6798 1.10233 4.83794 0.720657 5.11914 0.439453C5.40037 0.158258 5.782 8.25362e-05 6.17969 0H9.71973ZM11.0752 5.51758C10.9426 5.51758 10.8154 5.57029 10.7217 5.66406C10.6279 5.75783 10.5752 5.885 10.5752 6.01758L10.3252 16.0176C10.3252 16.1501 10.3779 16.2774 10.4717 16.3711C10.5654 16.4648 10.6926 16.5176 10.8252 16.5176C10.9578 16.5176 11.0849 16.4648 11.1787 16.3711C11.2725 16.2774 11.3252 16.1501 11.3252 16.0176L11.5752 6.01758C11.5752 5.885 11.5224 5.75783 11.4287 5.66406C11.3349 5.57029 11.2078 5.51758 11.0752 5.51758ZM4.8252 5.51074C4.69259 5.51074 4.56545 5.56346 4.47168 5.65723C4.378 5.75098 4.3252 5.8782 4.3252 6.01074L4.5752 16.0107C4.57527 16.1433 4.62798 16.2706 4.72168 16.3643C4.81543 16.4579 4.94265 16.5107 5.0752 16.5107C5.20774 16.5107 5.33496 16.4579 5.42871 16.3643C5.52241 16.2706 5.57512 16.1433 5.5752 16.0107L5.3252 6.01074C5.3252 5.8782 5.27239 5.75098 5.17871 5.65723C5.08494 5.56346 4.9578 5.51074 4.8252 5.51074ZM6.17969 1C6.04722 1.00008 5.91986 1.05283 5.82617 1.14648C5.7325 1.24015 5.6798 1.36755 5.67969 1.5V2H10.2197V1.5C10.2196 1.36755 10.1669 1.24015 10.0732 1.14648C9.97951 1.05294 9.85217 1 9.71973 1H6.17969Z"
									/>
								</svg>
							</button>
						</div>
					</div>
					<div class="cart-modal__total total">
						<div class="total__top">
							<div class="total__column">
								<div class="total__text _md">
									{{ $t('Total to pay') }}:
								</div>
							</div>
							<div class="total__column">
								<div class="total__coin">
									<div class="total__coin-number">
										{{ totalAmount.toFixed(2) }} {{ currencySymbol }}
									</div>
									<!--<div class="total__coin-icon _ibg-contain">
										<img src="@/assets/images/icons/coin.svg" />
									</div>-->
								</div>
							</div>
						</div>
						<!--<div class="total__real">
							<div class="total__real-number">
								{{ totalAmount.toFixed(2) }}
							</div>
							<div class="total__real-symbol">{{ currencySymbol }}</div>
						</div>-->
					</div>
					<div class="cart-modal__actions">
						<button
							class="cart-modal__action _btn-gray-primary"
							@click="handleClearCart"
						>
							{{ $t('clear cart') }}
						</button>
						<button
							class="cart-modal__action _btn-primary"
							@click="handleCheckout"
						>
							{{ $t('Checkout') }}
						</button>
					</div>
				</div>
			</div>
			<div class="cart-modal__empty _md" v-if="!cartContents.length">
				{{ $t(`Cart is empty!`) }}
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
	name: 'CartModal',
	components: {},
	props: {
		isAuth: {
			type: Boolean,
			required: true,
		},
		cartContents: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			countryId: '',
			error: '',
			isSubmitting: false,
			imgDomain: process.env.VUE_APP_STATIC_DOMAIN,
			loaderIsVisible: false,
		};
	},
	computed: {
		...mapGetters('app', ['currencySymbol', 'currencyCode']),
		totalAmount() {
			const sum = this.cartContents.reduce((total, item) => {
				const price = Number(item?.item?.price) || 0;
				const count = Number(item?.count) || 1;
				return total + price * count;
			}, 0);
			return Number(sum.toFixed(2));
		},
	},
	created() {},
	mounted() {
		console.log('cartContents', this.cartContents);
		this.isSubmitting = false;
	},
	methods: {
		...mapActions('cart', ['removeFromCart', 'fetchCartItems', 'clearCart']),
		...mapGetters('app', ['currencySymbol', 'currencyCode']),
		getImageUrl(item) {
			if (item.item.item_type == 'pack') {
				return item.item.img_url;
			} else {
				return this.imgDomain + item.item.img_url;
			}
		},
		handleClearCart() {
			this.clearCart();
		},
		handleCheckout() {
			this.$emit('close');
			this.$router.push('/checkout');
		},
		getSkinName(title) {
			if (!title) return '';
			const match = title.match(/\|\s*([^()]+?)(?:\(|$)/);
			return match ? match[1].trim() : title;
		},

		getWear(title) {
			if (!title) return '';
			const match = title.match(/\(([^)]+)\)/);
			return match ? match[1].trim() : '';
		},
		async handleDelete(item) {
			try {
				await this.removeFromCart({ id: item.item_id });
				if (this.fetchCartItems) await this.fetchCartItems();
				this.$toast?.success?.(this.$t('Item removed from cart'));
			} catch (err) {
				this.$toast?.error?.(this.$t('Failed to remove item'));
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.cart-modal {
	&__inner {
		max-width: 750px;
	}
	&__close {
	}
	&__top {
		display: flex;
		justify-content: center;
		gap: 6px;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 40, 15);
		}
		&-title {
			@include adaptiveValue('font-size', 32, 22);
		}
		&-count {
			font-size: 12px;
			font-weight: 400;
			color: var(--secondary-color);
			align-self: flex-end;
		}
	}
	&__content {
		max-width: 636px;
		margin: 0 auto;
	}
	&__list {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 35, 15);
		}
	}
	&__item {
		gap: 24px;
		display: flex;
		border-radius: var(--border-radius-primary);
		border: 1px solid rgba(255, 255, 255, 0.1);
		background-color: var(--bg-card-color);
		padding-top: 10px;
		@include adaptiveValue('padding-right', 30, 10, 1470, 768, 1);
		padding-bottom: 10px;
		@include adaptiveValue('padding-left', 30, 10, 1470, 768, 1);
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 15, 6);
		}
		@media (max-width: $md4) {
			flex-wrap: wrap;
			gap: 20px;
		}
	}
	&__wrapper {
		position: relative;
	}
	&__bg {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		z-index: -1;
	}
	&__image {
		min-width: 108px;
		height: 80px;
	}
	&__about {
		flex: 1 1 auto;
		align-self: center;
		@media (max-width: $md4) {
			flex: 1 1 calc(100% - 128px);
		}
		&-type {
			color: var(--secondary-color);
			font-weight: 500;
			font-size: 12px;
			line-height: 150%;
		}
	}
	&__info {
		display: flex;
		flex-wrap: wrap;
		gap: 6px;
		&:not(:last-child) {
			margin-bottom: 8px;
		}
		&-name,
		&-wear {
			white-space: nowrap;
			font-size: 16px;
			font-family: var(--font-family-inter);
			line-height: 150%;
		}
		&-name {
			color: var(--primary-color);
			font-weight: 700;
		}
		&-wear {
			color: var(--secondary-color);
			font-weight: 500;
		}
	}
	&__price {
		align-self: center;
		@media (max-width: $md4) {
			flex: 1 1 calc(100% - 70px);
		}
	}
	&__coin {
		display: flex;
		align-items: center;
		@include adaptiveValue('gap', 8, 6);
		&-number {
			font-size: 18px;
			font-weight: 700;
			font-family: var(--font-family-inter);
			line-height: 150%;
		}
		&-icon {
			min-width: 15px;
			height: 15px;
		}
	}
	&__real {
		display: flex;
		gap: 3px;

		@media (min-width: $md4) {
			justify-content: flex-end;
		}
		&-number,
		&-symbol {
			color: var(--secondary-color);
			font-size: 12px;
			line-height: 150%;
			font-weight: 500;
		}
	}
	&__delete {
		background-color: transparent;
		min-width: 50px;
		position: relative;
		@media (any-hover: hover) {
			&:hover {
				svg {
					path {
						fill: var(--primary-color);
					}
				}
			}
		}
		svg {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			min-width: 24px;
			height: 24px;
			path {
				fill: var(--error-color);
				transition: fill 0.3s ease 0s;
			}
		}
	}
	&__total {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 130, 20);
		}
	}
	&__actions {
		@media (min-width: $md6) {
			display: flex;
			gap: 20px;
		}
	}
	&__action {
		@media (min-width: $md6) {
			flex: 0 1 50%;
		}
		@media (max-width: $md6) {
			width: 100%;
			&:not(:last-child) {
				margin-bottom: 6px;
			}
		}
	}
	&__empty {
		display: block;
		text-align: center;
		color: var(--secondary-color);
		text-transform: capitalize;
		@include adaptiveValue('margin-top', 40, 20);
	}
}

.total {
	&__top {
		display: flex;
		gap: 20px;
		justify-content: space-between;
	}
	&__column {
	}
	&__text {
		font-family: var(--font-family-inter);
		font-weight: 700;
		line-height: 150%;
		color: var(--primary-color);
		text-transform: capitalize;
	}
	&__coin {
		display: flex;
		align-items: center;
		@include adaptiveValue('gap', 8, 6);
		&-number {
			@include adaptiveValue('font-size', 24, 18);
			font-weight: 700;
			font-family: var(--font-family-inter);
			line-height: 150%;
		}
		&-icon {
			@include adaptiveValue('min-width', 20, 15);
			@include adaptiveValue('height', 20, 15);
		}
	}
	&__real {
		display: flex;
		gap: 3px;
		justify-content: flex-end;
		&-number,
		&-symbol {
			color: var(--secondary-color);
			font-size: 12px;
			line-height: 150%;
			font-weight: 500;
		}
	}
}
</style>
